export const TIMELINE_WIDTH = 360;
export const MIN_TIMELINE_WIDTH = 160;
export const SAFE_RESIZE_THRESHOLD = 50;
